import { Currency as CurrencyApi } from '@vendasta/billing';

export enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  EUR = 'EUR',
  AUD = 'AUD',
  GBP = 'GBP',
  NZD = 'NZD',
  BRL = 'BRL',
  CHF = 'CHF',
  CNY = 'CNY',
  CZK = 'CZK',
  INR = 'INR',
  JPY = 'JPY',
  KHR = 'KHR',
  KRW = 'KRW',
  MXN = 'MXN',
  NOK = 'NOK',
  RUB = 'RUB',
  SEK = 'SEK',
  SGD = 'SGD',
  TRY = 'TRY',
  ZAR = 'ZAR',
  DZD = 'DZD',
  AWG = 'AWG',
  FJD = 'FJD',
  KYD = 'KYD',
}

export function currencyFromApi(cApi: CurrencyApi | undefined): Currency {
  switch (cApi) {
    case CurrencyApi.USD:
      return Currency.USD;
    case CurrencyApi.CAD:
      return Currency.CAD;
    case CurrencyApi.EUR:
      return Currency.EUR;
    case CurrencyApi.AUD:
      return Currency.AUD;
    case CurrencyApi.GBP:
      return Currency.GBP;
    case CurrencyApi.NZD:
      return Currency.NZD;
    case CurrencyApi.BRL:
      return Currency.BRL;
    case CurrencyApi.CHF:
      return Currency.CHF;
    case CurrencyApi.CNY:
      return Currency.CNY;
    case CurrencyApi.CZK:
      return Currency.CZK;
    case CurrencyApi.INR:
      return Currency.INR;
    case CurrencyApi.JPY:
      return Currency.JPY;
    case CurrencyApi.KHR:
      return Currency.KHR;
    case CurrencyApi.KRW:
      return Currency.KRW;
    case CurrencyApi.MXN:
      return Currency.MXN;
    case CurrencyApi.NOK:
      return Currency.NOK;
    case CurrencyApi.RUB:
      return Currency.RUB;
    case CurrencyApi.SEK:
      return Currency.SEK;
    case CurrencyApi.SGD:
      return Currency.SGD;
    case CurrencyApi.TRY:
      return Currency.TRY;
    case CurrencyApi.ZAR:
      return Currency.ZAR;
    case CurrencyApi.DZD:
      return Currency.DZD;
    case CurrencyApi.AWG:
      return Currency.AWG;
    case CurrencyApi.FJD:
      return Currency.FJD;
    case CurrencyApi.KYD:
      return Currency.KYD;
    default:
      return Currency.USD;
  }
}

export function currencyToApi(currency: Currency | undefined): CurrencyApi {
  switch (currency) {
    case Currency.USD:
      return CurrencyApi.USD;
    case Currency.CAD:
      return CurrencyApi.CAD;
    case Currency.EUR:
      return CurrencyApi.EUR;
    case Currency.AUD:
      return CurrencyApi.AUD;
    case Currency.GBP:
      return CurrencyApi.GBP;
    case Currency.NZD:
      return CurrencyApi.NZD;
    case Currency.BRL:
      return CurrencyApi.BRL;
    case Currency.CHF:
      return CurrencyApi.CHF;
    case Currency.CNY:
      return CurrencyApi.CNY;
    case Currency.CZK:
      return CurrencyApi.CZK;
    case Currency.INR:
      return CurrencyApi.INR;
    case Currency.JPY:
      return CurrencyApi.JPY;
    case Currency.KHR:
      return CurrencyApi.KHR;
    case Currency.KRW:
      return CurrencyApi.KRW;
    case Currency.MXN:
      return CurrencyApi.MXN;
    case Currency.NOK:
      return CurrencyApi.NOK;
    case Currency.RUB:
      return CurrencyApi.RUB;
    case Currency.SEK:
      return CurrencyApi.SEK;
    case Currency.SGD:
      return CurrencyApi.SGD;
    case Currency.TRY:
      return CurrencyApi.TRY;
    case Currency.ZAR:
      return CurrencyApi.ZAR;
    case Currency.DZD:
      return CurrencyApi.DZD;
    case Currency.AWG:
      return CurrencyApi.AWG;
    case Currency.FJD:
      return CurrencyApi.FJD;
    case Currency.KYD:
      return CurrencyApi.KYD;
    default:
      return CurrencyApi.USD;
  }
}
